/// <amd-module name="Build/Admin/Pool/Stores/PoolAnalyticsStore" />
import { extractODataError } from "Analytics/Common/Utilities/AnalyticsExceptionUtilities";
import { ITrendReportConfiguration } from "Analytics/Shared/Common/Types";
import { ConfigurationUtility } from "Analytics/Shared/TrendChart/Common/ConfigurationUtility";
import { ITrendChartData } from "Analytics/Shared/TrendChart/Common/Types";
import { Store } from "VSS/Reflux/Store";

export interface IPoolAnalyticsTrendCardState {
    confValues?: ITrendReportConfiguration;
    errorText?: string;
    data?: ITrendChartData;
}

export class PoolAnalyticsStore extends Store {
    protected _publicState: IPoolAnalyticsTrendCardState = {};
    protected _privateState: IPoolAnalyticsTrendCardState = {};
    constructor() {
        super("PoolAnalyticsStoreChanged");
    }

    public getPublicTrendState(): IPoolAnalyticsTrendCardState {
        return this._publicState;
    }

    public getPrivateTrendState(): IPoolAnalyticsTrendCardState {
        return this._privateState;
    }

    public _onErrorPublic = (error: Error) => {
        const errorText = extractODataError(error);
        this._publicState.errorText = errorText;
        this.emitChanged();
    };

    public _onErrorPrivate = (error: Error) => {
        const errorText = extractODataError(error);
        this._privateState.errorText = errorText;
        this.emitChanged();
    };

    public _onUpdateConfiguration = (confValues: ITrendReportConfiguration) => {
        if (!this._publicState.confValues || !ConfigurationUtility.areConfValuesEqual(this._publicState.confValues, confValues)) {
            this._publicState.errorText = undefined;
            this._publicState.data = undefined;
            this._publicState.confValues = { ...confValues };
            this.emitChanged();
        }
        if (!this._privateState.confValues || !ConfigurationUtility.areConfValuesEqual(this._privateState.confValues, confValues)) {
            this._privateState.errorText = undefined;
            this._privateState.data = undefined;
            this._privateState.confValues = { ...confValues };
            this.emitChanged();
        }
    };

    public _onUpdatePublicData = (cardData: ITrendChartData) => {
        if (cardData) {
            this._publicState.errorText = undefined;
            this._publicState.data = cardData;
            this.emitChanged();
        }
    };

    public _onUpdatePrivateData = (cardData: ITrendChartData) => {
        if (cardData) {
            this._privateState.errorText = undefined;
            this._privateState.data = cardData;
            this.emitChanged();
        }
    };
}
